<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--featured box style1 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Feature Box <span>Style 1</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-6 z-index-1">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="featured-item style-1 active">
              <div class="featured-icon"> <i class="flaticon-idea"></i>
              </div>
              <div class="featured-title">
                <h5>Design</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mt-5 mt-md-0">
            <div class="featured-item style-1">
              <div class="featured-icon"> <i class="flaticon-histogram"></i>
              </div>
              <div class="featured-title">
                <h5>Marketing</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mt-5">
            <div class="featured-item style-1">
              <div class="featured-icon"> <i class="flaticon-analytics"></i>
              </div>
              <div class="featured-title">
                <h5>Data Analytics</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mt-5">
            <div class="featured-item style-1">
              <div class="featured-icon"> <i class="flaticon-optimization"></i>
              </div>
              <div class="featured-title">
                <h5>Optimization</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--featured box style1 end-->


<!--featured box style2 start-->

<section class="pos-r">
  <div id="particles-js"></div>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Feature Box <span>Style 2</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-ui"></i>
            <span>01</span>
          </div>
          <div class="featured-title">
            <h5>UX Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-domain"></i>
            <span>02</span>
          </div>
          <div class="featured-title">
            <h5>Development</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-challenges"></i>
            <span>03</span>
          </div>
          <div class="featured-title">
            <h5>Strategy</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--featured box style2 end-->


<!--featured box style3 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Feature Box <span>Style 3</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-ui"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>UX Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>          
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3 active">
          <div class="featured-icon"> <i class="flaticon-analysis"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Development</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-challenges"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Strategy</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-idea"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Web Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-optimization"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Optimization</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5">
        <div class="featured-item style-3">
          <div class="featured-icon"> <i class="flaticon-support"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>24/7 Support</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--featured box style3 end-->


<!--featured box style4 end-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Feature Box <span>Style 4</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="owl-carousel" data-items="3" data-md-items="2" data-sm-items="1" data-autoplay="true">
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-domain"></i>
              </div>
              <div class="featured-title">
                <h5>Web Development</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4 active">
              <div class="featured-icon"> <i class="flaticon-analytics"></i>
              </div>
              <div class="featured-title">
                <h5>Data Analytics</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-challenges"></i>
              </div>
              <div class="featured-title">
                <h5>Strategy</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-ui"></i>
              </div>
              <div class="featured-title">
                <h5>UX Design</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-histogram"></i>
              </div>
              <div class="featured-title">
                <h5>Marketing</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--featured box style4 end-->


</div>

<!--body content end--> 
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: "shortcode-features",
        }
    }
}
</script>